const isInLandscapeMode = () => window.matchMedia('(orientation: landscape)').matches;

export default isInLandscapeMode;
